<template>
  <layoutContainer>
    <!--  音视频  -->
    <consulting-room ref="refConsultingRoom" @dataUpdate="refreshDetailData"/>
    <!--  小提示  -->
    <little-tip v-if="detailData.appointmentId" :detail-data="detailData"/>
    <!--  详情  -->
    <consulting-detail ref="refConsultingDetail" v-if="detailData.appointmentId" :detail-data="detailData" @callGetTableData="handleCallGetTableData" @callGetDetail="handleCallGetDetail"/>
    <!--  修改预约记录  -->
    <modify-appointment-history ref="refModifyAppointmentHistory" v-if="detailData.appointmentId" :detail-data="detailData" :open-change-time-dialog="openChangeTimeDialog" @callGetDetail="handleCallGetDetail"/>
  </layoutContainer>
</template>
<script>
import ConsultingRoom from './components/ConsultingRoom.vue'
import LittleTip from './components/LittleTip.vue'
import ConsultingDetail from './components/ConsultingDetail.vue'
import ModifyAppointmentHistory from './components/ModifyAppointmentHistory.vue'
export default {
  components: {
    ConsultingRoom,
    LittleTip,
    ConsultingDetail,
    ModifyAppointmentHistory
  },
  data() {
    return {
      detailData: {}
    }
  },
  mounted() {

  },
  methods: {
    refreshDetailData(detailData) {
      this.detailData = {...detailData}
    },
    openChangeTimeDialog(type,row) {
      this.$refs.refConsultingDetail.handleChangeTime(type,row)
    },
    handleCallGetDetail() {
      console.log('///ddd=====')
      if (this.$refs.refConsultingRoom) {
        console.log('///ddd')
        this.$refs.refConsultingRoom.getDetail(true);
      }
    },
    handleCallGetTableData() {
      if (this.$refs.refModifyAppointmentHistory) {
        this.$refs.refModifyAppointmentHistory.getTableData();
      }
    }
  }
}
</script>
<style lang="scss">
.consulting{

}
</style>
